export const consentsEn = {
  // Direct translations for consent types - can be used with transloco
  PRIVACY_POLICY: 'Privacy policy',
  TERMS_OF_USE: 'Terms of use',
  MARKETING: 'Marketing communications',
  AI_MATCHING: 'AI matching',
  AI_PARSING: 'AI CV parsing',
  COOKIES: 'Cookies',
  ANALYTICS: 'Analytics and Statistics',
  THIRD_PARTY_SHARING: 'Third-party Data Sharing',

  // Descriptions
  descriptions: {
    PRIVACY_POLICY: 'Acceptance of our Privacy Policy is required to use our services and process your personal data.',
    TERMS_OF_USE: 'Acceptance of our Terms of Use is mandatory for accessing and using our services.',
    MARKETING: 'Receive promotional emails, newsletters, and marketing communications about our services, job opportunities, and special offers.',
    AI_MATCHING:
      'When enabled, Sameta can analyze your profile, CV data, preferences, and activity to recommend relevant jobs and support AI-assisted recruiter matching. Turn it off if you do not want automated matching. For more information please review our',
    AI_PARSING:
      'When enabled, Sameta can use AI to read an uploaded CV and prefill profile fields. This saves time when updating your profile and is separate from AI matching. For more information please review our',
    COOKIES: 'Allow us to use cookies to enhance your browsing experience, remember your preferences, and provide personalized content.',
    ANALYTICS: 'Allow us to collect anonymous usage statistics and analytics data to improve our services and understand user behavior.',
    THIRD_PARTY_SHARING: 'Allow us to share your data with trusted third-party partners for job matching and recruitment purposes.',
  },

  // UI labels and content
  pages: {
    settings: {
      consents: {
        title: 'Consent management',
        description:
          'Manage your privacy preferences and data processing consents. You can grant or withdraw consent for various data processing activities at any time.',
        loading: 'Loading your consent preferences...',
        categories: {
          essential: 'Essential consents',
          essentialDescription: 'These consents are required for the basic functionality of our services and cannot be disabled.',
          optional: 'Optional consents',
          optionalDescription: 'These consents are optional and help us improve our services. You can enable or disable them at any time.',
        },
        grantedOn: 'Granted on',
        withdrawnOn: 'Withdrawn on',
        version: 'Version',
        required: 'Required',
        footerInfo:
          'Changes to your consent preferences take effect immediately. You can modify these settings at any time. For more information about how we process your data, please review our',
      },
    },
  },
};
